import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const parseDateValue = (value) => {
  if (String(value).split("-").length !== 3
    || !dayjs(value, 'DD-MM-YYYY').isValid()) {
    return value;
  }
  return dayjs(value, 'DD-MM-YYYY').format('YYYY-MM-DD') + 'T00:00:00.000Z';
};
